import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCC_Pesada = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'cc_pesada',
        name: 'Cambio Corral Caravana',
        component: ViewCC_Pesada,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
